module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/home/key-2aedcda410860fd9332654de728d4e39.svg";